// a helper util for creating a new state for company team members

const getCompanyTeamMemberState = (action, result, idField = 'userId') =>
  action?.data[idField] ? { [action.data[idField]]: result } : {};

export default getCompanyTeamMemberState;
